var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96875 9.25H3.75V13H6.25V11.75H8.96875C9.65938 13.7031 11.8031 14.725 13.7531 14.0344C15.7062 13.3438 16.7281 11.2 16.0375 9.25C15.3469 7.29688 13.2031 6.275 11.2531 6.96563C10.1844 7.34375 9.34375 8.18437 8.96875 9.25ZM12.5 9.25C13.1906 9.25 13.75 9.80937 13.75 10.5C13.75 11.1906 13.1906 11.75 12.5 11.75C11.8094 11.75 11.25 11.1906 11.25 10.5C11.25 9.80937 11.8094 9.25 12.5 9.25ZM2.5 3H6.25V0.5H2.5C1.11875 0.5 0 1.61875 0 3V6.75H2.5V3ZM2.5 20.5H6.25V18H2.5V14.25H0V18C0 19.3813 1.11875 20.5 2.5 20.5ZM17.5 18H13.75V20.5H17.5C18.8813 20.5 20 19.3813 20 18V14.25H17.5V18ZM17.5 0.5H13.75V3H17.5V6.75H20V3C20 1.61875 18.8813 0.5 17.5 0.5Z",
    fill: "#FFBB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/changePassword.e4b660ab4e4b7fb1cc5cb0082b37dfff.svg";
export { ForwardRef as ReactComponent };